import { AppManifest } from '../services/appManifest/AppManifest';

export const isProdVersion = Boolean(AppManifest.getFlag('isProdVersion'));
